import { MAP_RESTRICTED_COUNTRIES, MAP_RESTRICTED_DEALERS } from '../../../constants/mapsRestrictions';
/**
 * Calculate the bounds of a list of positions in order to all positions are in the bounds area
 * @param locations list of positions with shape { lat, lng }
 * @returns bounds with shape { north, east, south, west }
 */
export const getBounds = (locations) => {
    const bounds = new google.maps.LatLngBounds();
    locations.forEach((location) => bounds.extend(location));
    return bounds.toJSON();
};
/**
 * Helper to create LatLng objects
 */
export const getLatLng = (latitude, longitude) => ({
    lat: latitude,
    lng: longitude
});
export const getIsMapHidden = ({ userCountryCode, dealerCode }) => {
    const isInRestrictedCountry = MAP_RESTRICTED_COUNTRIES.has(userCountryCode);
    const isRestrictedDealer = MAP_RESTRICTED_DEALERS.has(dealerCode);
    return isInRestrictedCountry || isRestrictedDealer;
};
